import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { handleCheckbox } from '../../../actions/data'
import Classnames from 'classnames'
import { addScreenedFund, removeScreendFund, removeSearchTicker } from '../../../actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClock, faEdit, faInfo } from '@fortawesome/free-solid-svg-icons'
import './ModelRow.css'

library.add(faClock, faInfo, faEdit)


const ModelRow = ({ modelStrategy, screenedFunds, striped, openMenu, addScreenedFund, removeScreendFund, removeSearchTicker }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckbox = (strategyToEdit) => {
    const { id, name, periodicity, ticker } = strategyToEdit;
    const externalID = id;
    const type = 'wt_model';
    const rebalance_fq = periodicity;
    const filteredFund = { id, externalID, ticker, rebalance_fq, name, type };
    const foundFund = screenedFunds && screenedFunds.find(fund => fund.id === filteredFund.id);
    if (foundFund) {
      removeScreendFund(externalID);
      removeSearchTicker(externalID);
      setIsChecked(false);
    } else {
      addScreenedFund(filteredFund);
      setIsChecked(true);
    }
  };

  useEffect(() => {
    const foundFund = screenedFunds && screenedFunds.find(fund => fund.id === modelStrategy.id);
    setIsChecked(foundFund ? true : false);
  }, [screenedFunds, modelStrategy.id]);

  return (
    <div>
      <div className={Classnames('strategyModelRow', { striped: striped && !openMenu }, { opened: openMenu })}>
        <div>
          <FontAwesomeIcon style={{ color: isChecked ? 'initial' : '#0FACE7', marginLeft: '10px' }} size='2x' icon='plus-circle' onClick={() => handleCheckbox(modelStrategy)} />
        </div>
        <div className='name'>{modelStrategy.name +'(' + modelStrategy.ticker + ')'}</div>
        <div className='date'>{new Date(modelStrategy.inceptionDate).toLocaleDateString()}</div>
      </div>
    </div>
  );
};

ModelRow.defaultProps = {
  saveInProgress: false,
  openMenu: false,
  striped: false
};

function mapStateToProps(state) {
  return {
    data: state.fundData,
    params: state.params,
    personalStrategies: state.strategies,
    screenedFunds: state.params.screenedFunds
  }
}

export default withRouter(
  connect(mapStateToProps, {
    handleCheckbox,
    addScreenedFund,
    removeScreendFund,
    removeSearchTicker
  })(ModelRow)
)
